/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

const CLINICMINDS_SRC =
  "https://schedule.clinicminds.com/assets/widget/widget.js"

// The ClinicMinds widget scans the DOM for `.clinicminds-scheduler-button`
// elements when it executes, so it has to re-run after every route change.
// Loading is deferred to browser idle or the user's first interaction
// (same pattern as the gtag loader in footer.js) so the third-party script
// never competes with the page's own rendering. Until it loads, the booking
// buttons still work as plain links to schedule.clinicminds.com.
function loadClinicMindsScript() {
  const oldScript = document.querySelector(`script[src="${CLINICMINDS_SRC}"]`)
  if (oldScript) {
    oldScript.remove()
  }

  const script = document.createElement("script")
  script.src = CLINICMINDS_SRC
  script.async = true
  document.body.appendChild(script)
}

let cancelPendingLoad = null

export const onRouteUpdate = () => {
  // a navigation happened before the previous load fired — supersede it
  if (cancelPendingLoad) {
    cancelPendingLoad()
  }

  const events = ["scroll", "mousemove", "touchstart", "keydown"]
  let done = false

  const load = () => {
    if (done) return
    done = true
    events.forEach((evt) => window.removeEventListener(evt, load))
    cancelPendingLoad = null
    loadClinicMindsScript()
  }

  cancelPendingLoad = () => {
    done = true
    events.forEach((evt) => window.removeEventListener(evt, load))
    cancelPendingLoad = null
  }

  events.forEach((evt) => window.addEventListener(evt, load, { passive: true }))

  if ("requestIdleCallback" in window) {
    requestIdleCallback(load, { timeout: 3500 })
  } else {
    setTimeout(load, 2000)
  }
}
